
import { Main } from './src/main';

import.meta.glob([
  './assets/**'
]);

new Main();
